"use client";

import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { isWaveDirectMessage } from "@/helpers/waves/wave.helpers";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
interface WaveDropActionsCopyLinkProps {
  readonly drop: ApiDrop;
  readonly isDropdownItem?: boolean | undefined;
  readonly onCopy?: (() => void) | undefined;
}
const WaveDropActionsCopyLink: React.FC<WaveDropActionsCopyLinkProps> = t0 => {
  const $ = _c(35);
  const {
    drop,
    isDropdownItem: t1,
    onCopy
  } = t0;
  const isDropdownItem = t1 === undefined ? false : t1;
  const [copied, setCopied] = useState(false);
  const myStream = useMyStreamOptional();
  let t2;
  if ($[0] !== myStream?.directMessages.list) {
    t2 = myStream?.directMessages.list ?? [];
    $[0] = myStream?.directMessages.list;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const directMessageWaves = t2;
  const isTemporaryDrop = _temp;
  let t3;
  if ($[2] !== directMessageWaves || $[3] !== drop || $[4] !== onCopy) {
    t3 = () => {
      if (isTemporaryDrop(drop)) {
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      } ?? undefined;
      const isDirectMessage = isWaveDirectMessage(drop.wave.id, waveDetails, directMessageWaves);
      const dropLink = `${publicEnv.BASE_ENDPOINT}${getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage,
        isApp: false
      })}`;
      navigator.clipboard.writeText(dropLink).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        onCopy?.();
      });
    };
    $[2] = directMessageWaves;
    $[3] = drop;
    $[4] = onCopy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const copyToClipboard = t3;
  let t4;
  if ($[6] !== drop) {
    t4 = isTemporaryDrop(drop);
    $[6] = drop;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isDisabled = t4;
  let t5;
  if ($[8] !== copied || $[9] !== isDisabled) {
    t5 = () => {
      if (isDisabled) {
        return "Unavailable";
      }
      if (copied) {
        return "Copied!";
      }
      return "Copy link";
    };
    $[8] = copied;
    $[9] = isDisabled;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const getLinkText = t5;
  if (isDropdownItem) {
    const t6 = `tw-flex tw-w-full tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-transition-colors tw-duration-200 ${isDisabled ? "tw-cursor-default tw-text-iron-500 tw-opacity-50" : "tw-cursor-pointer tw-text-iron-300 desktop-hover:hover:tw-bg-iron-800"}`;
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <svg className="tw-h-4 tw-w-4 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" /></svg>;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    const t8 = getLinkText();
    let t9;
    if ($[12] !== t8) {
      t9 = <span className="tw-text-sm tw-font-medium">{t8}</span>;
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== copyToClipboard || $[15] !== isDisabled || $[16] !== t6 || $[17] !== t9) {
      t10 = <button onClick={copyToClipboard} disabled={isDisabled} className={t6}>{t7}{t9}</button>;
      $[14] = copyToClipboard;
      $[15] = isDisabled;
      $[16] = t6;
      $[17] = t9;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    return t10;
  }
  const t6 = `icon tw-group tw-flex tw-h-full tw-items-center tw-gap-x-2 tw-rounded-full tw-border-0 tw-bg-transparent tw-px-2 tw-text-[0.8125rem] tw-font-medium tw-leading-5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out ${isDisabled ? "tw-cursor-default tw-opacity-50" : "tw-cursor-pointer"}`;
  let t7;
  if ($[19] !== drop || $[20] !== isDisabled) {
    t7 = !isDisabled ? {
      "data-tooltip-id": `copy-link-${drop.id}`
    } : {};
    $[19] = drop;
    $[20] = isDisabled;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" /></svg>;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== copyToClipboard || $[24] !== isDisabled || $[25] !== t6 || $[26] !== t7) {
    t9 = <button className={t6} onClick={copyToClipboard} disabled={isDisabled} aria-label="Copy link" {...t7}>{t8}</button>;
    $[23] = copyToClipboard;
    $[24] = isDisabled;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== drop || $[29] !== getLinkText || $[30] !== isDisabled) {
    t10 = !isDisabled && <Tooltip id={`copy-link-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{getLinkText()}</span></Tooltip>;
    $[28] = drop;
    $[29] = getLinkText;
    $[30] = isDisabled;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[32] = t10;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
};
export default WaveDropActionsCopyLink;
function _temp(drop_0) {
  return drop_0.id.startsWith("temp-");
}